import api from '../../services/api'
import {
  TAG_IS_FETCHING,
  TAG_GET
} from '../types'

function getTags () {
  return (dispatch) => {
    dispatch({
      type: TAG_IS_FETCHING,
      payload: true
    })

    return api.tag.getTags().then((response) => {
      if (response && !response.data.error) {
        dispatch({
          type: TAG_GET,
          payload: response.data.result
        })
        return response
      }
    }).then((response) => {
      dispatch({
        type: TAG_IS_FETCHING,
        payload: false
      })
      return response
    })
  }
}

function createTag (value) {
  return (dispatch) => {
    return api.tag.createTag(value).then((response) => {
      if (response && !response.data.error) {
        dispatch(getTags())
      }
      return response
    })
  }
}

function deleteTag (id) {
  return (dispatch) => {
    return api.tag.deleteTag(id).then((response) => {
      if (response && !response.data.error) {
        dispatch(getTags())
      }
      return response
    })
  }
}

function editTag (id, name) {
  return (dispatch) => {
    return api.tag.editTag(id, name).then((response) => {
      if (response && !response.data.error) {
        dispatch(getTags())
      }
      return response
    })
  }
}

export {
  getTags,
  createTag,
  deleteTag,
  editTag
}



// WEBPACK FOOTER //
// ./src/store/actions/tag.js